module.exports = __webpack_public_path__ + "static/media/ladot.875eef34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ladot.jpg
// module id = 507
// module chunks = 0